import { render, staticRenderFns } from "./EnderecoFd.vue?vue&type=template&id=a040770a&scoped=true&"
import script from "./EnderecoFd.vue?vue&type=script&lang=js&"
export * from "./EnderecoFd.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoFd.vue?vue&type=style&index=0&id=a040770a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a040770a",
  null
  
)

export default component.exports